import type { ImgHTMLAttributes } from 'react'

/** Every picture sign of the interface (docs/game_bible/art_prompts_ui.md, section 1; art_prompts_skills.md):
 *  /assets/icons/<name>.webp, 128 px. */
export const EMBLEM_NAMES = [
  'nav.location', 'nav.hero', 'nav.inventory', 'nav.journal', 'nav.map', 'nav.arena', 'nav.clans', 'nav.gods', 'nav.settings', 'nav.more',
  'res.hp', 'res.stamina', 'res.mana', 'res.xp', 'res.silver', 'res.crystal',
  'attr.str', 'attr.vit', 'attr.dex', 'attr.wis', 'attr.lck', 'attr.kno',
  'stat.power', 'stat.spirit_power', 'stat.weapon_damage', 'stat.armor', 'stat.spirit_armor', 'stat.accuracy', 'stat.evasion', 'stat.parry',
  'stat.crit', 'stat.block', 'stat.status_power', 'stat.status_resist',
  'zone.head', 'zone.body', 'zone.legs', 'act.strike', 'act.onslaught', 'act.charm', 'act.rest',
  'battle.focus', 'battle.twilight', 'battle.confirm', 'battle.surrender', 'battle.target', 'battle.foe',
  'status.bleed', 'status.stun', 'status.silence', 'status.sunder', 'status.named', 'status.trip', 'status.pinned', 'status.seal', 'status.disarm',
  'status.hobbled', 'status.ward', 'status.circle', 'status.song', 'status.last_stand', 'status.circle_rule',
  'nav.skills', 'skill.technique', 'skill.stance', 'skill.spell', 'skill.sign', 'skill.passive', 'skill.master',
  'slot.weapon', 'slot.offhand', 'slot.head', 'slot.shoulder', 'slot.body', 'slot.gloves', 'slot.belt', 'slot.legs', 'slot.charm',
  'kind.gear', 'kind.material', 'kind.consumable', 'kind.quest', 'kind.clue', 'kind.cosmetic',
  'loc.talk', 'loc.inspect', 'loc.enter', 'loc.exit', 'loc.shop', 'loc.board', 'loc.task',
  'map.fish', 'map.herb', 'map.danger', 'map.safe', 'map.lock', 'map.toll', 'map.fog', 'map.fog_known', 'map.place', 'map.travel',
  'journal.testimony', 'journal.item', 'journal.observation', 'reward.item', 'reward.saga', 'reward.trophy',
  'arena.duel', 'arena.team', 'arena.rated', 'arena.people', 'arena.bots', 'arena.rating',
  'injury.light', 'injury.heavy', 'injury.healer', 'creation.custom', 'system.loading', 'system.error', 'system.lock',
] as const

export type EmblemName = (typeof EMBLEM_NAMES)[number]

type EmblemProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'title'> & {
  name: EmblemName
  size?: number
  /** Accessible name; without it the sign is decorative. */
  title?: string
}

/** A picture sign of the interface. Decorative unless a title is given. */
export function Emblem({ name, size = 24, title, className, ...props }: EmblemProps) {
  return (
    <img
      className={className ? `em ${className}` : 'em'}
      src={`/assets/icons/${name}.webp`}
      width={size}
      height={size}
      alt={title ?? ''}
      title={title}
      aria-hidden={title ? undefined : true}
      draggable={false}
      {...props}
    />
  )
}
